import React from "react";
import Header from "./Header";
import { Grid, Row, Col } from "react-flexbox-grid";
import Typography from "@material-ui/core/Typography";
import "../css/style.styl";

class Page extends React.Component {
  render() {
    const { title, children } = this.props;
    return (
      <>
        <Header />
        <Grid style={{ marginTop: "94px"}}>
          <Row>
            <Col xs={12}>
              {title ? (
                <Typography
                  variant="h2"
                  gutterBottom
                  style={{
                    textAlign: 'center',
                    textTransform: 'uppercase',
                    fontFamily: 'Saira Extra Condensed',
                    color: 'white',
                    fontWeight: '600',
                    letterSpacing: '5.52px'
                  }}
                >
                  {title}
                </Typography>
              ) : null}
              {children}
            </Col>
          </Row>
        </Grid>
      </>
    );
  }
}

export default Page;
